window.VideoUploader = new function () {
    this.vars = {
        token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    /**
     * Starts the video upload process.
     * Shows the progress UI and handles the AJAX request.
     *
     * @param string form - The form selector.
     * @param string video - The video input selector.
     * @return void
     */
    this.uploadVideo = function (form, video, file_path) {
        jQuery(form).find('button[type="submit"]').prop('disabled', true);

        var $form = jQuery(form);
        var $videoInput = $form.find(video);
        var fileInput = $form.find(video)[0];

        if (!fileInput.files.length) {
            alert('Please select a file.');
            return;
        }

        var file = fileInput.files[0];
        var formData = new FormData();
        formData.append('video', file);
        formData.append('file_path', file_path);
        formData.append('_token', VideoUploader.vars.token);

        // Show progress UI
        jQuery(form + ' .progressWrapper').show();

        jQuery.ajax({
            xhr: function () {
                var xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = Math.round((evt.loaded / evt.total) * 100);
                        jQuery(form + ' .uploadProgress').val(percentComplete);
                        jQuery(form + ' .progressPercent').text(percentComplete + '%');
                    }
                }, false);
                return xhr;
            },
            url: '/media/upload-video',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                // Assume `response.path` contains the saved file path
                if (response && response.path) {
                    // Add hidden field with uploaded path
                    $form.append('<input type="hidden" name="uploaded_video_path" value="' + response.path + '" />');
                    // Remove the file input so it does not get submitted
                    $videoInput.remove();

                    // Now submit the full form
                    $form.off('submit'); // prevent re-triggering uploadFiles
                    $form.submit();
                } else {
                    console.log('Upload succeeded but no path returned.');
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error("Upload failed:", {
                    status: textStatus,
                    error: errorThrown,
                    response: jqXHR.responseText
                });

                if(errorThrown == 'Unprocessable Content') {
                    var responseText = JSON.parse(jqXHR.responseText);
                    $form.find('.error-notice').text(responseText.message);
                }

                $form.find('.error-notice').show();
                $form.find('.progress-notice').hide();
            }
        });
    };
};
